module.exports = __webpack_public_path__ + "static/media/ATHLONFX57.92f5e37d.jpg";